import { Component, OnInit, Input} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, NavigationStart } from '@angular/router';

//import { GridOptions, ColDef, AllModules } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';


import { WorkOrderService } from '../../../../common/services/work-order.service';
import { RouterLinkRendererComponent } from '../../../../common/components/ag-grid/router-link-renderer.component';
import { UserIdentity } from '../../../../models/user-identity.model';
import { AuthService } from '../../../../services/auth.service';
import { OrganizationStub } from '../../../../common/models/organization.model';
import { FlowInstanceService } from '../../../../flow/services/flow-instance.service';
import { FlowIndex } from '../../../../common/models/flow.dto';
import { DateService } from '../../../../common/services/date.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { dateComparator } from '../../../../common/components/data-table/comparators/data-table.comparators';
import { DataCorrectionService } from '../../../../services/dataCorrection.service';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { ModalInfoComponent } from '../../../../common/components/ag-grid/modal-info.component';

@Component({
    selector: 'data-correction-requests-external-widget',
    templateUrl: './data-correction-requests-external-widget.component.html',
    styleUrls: ['./data-correction-requests-external-widget.component.scss'],
    standalone: false
})
export class DataCorrectionRequestsExternalWidgetComponent implements OnInit {
    @Input() widgetTitle: string;


	notSubmittedGridOptions: GridOptions;
	notSubmittedGridApi?: GridApi;
	adHocReviewGridOptions: GridOptions;
	adHocReviewGridApi?: GridApi;
	pendingReviewGridOptions: GridOptions;
	pendingReviewGridApi?: GridApi;
	approvedGridOptions: GridOptions;
	approvedGridApi?: GridApi;
	returnedGridOptions: GridOptions;
	returnedGridApi?: GridApi;
	deniedGridOptions: GridOptions;
	deniedGridApi?: GridApi;
    orgStubs: OrganizationStub[];
    subscriptions: Subscription = new Subscription();
    notSubmittedDataCorrectionRequests: FlowIndex[];
    pendingReviewDataCorrectionRequests: FlowIndex[];
    approvedDataCorrectionRequests: FlowIndex[];
    returnedDataCorrectionRequests: FlowIndex[];
    pendingDenialDataCorrectionRequests: FlowIndex[];
    deniedDataCorrectionRequests: FlowIndex[];
    selectedItem: any;

    columnApplicationNumberColumn = {
        headerName: 'Application #',
        headerTooltip: 'Application #',
        tooltipField: 'flowIdentifier',
        field: 'flowIdentifier',
        cellRendererSelector: (params) => {
            if (params.data.onBehalf) {
                return {
                    component: ModalInfoComponent,
                    params: {
                        modalText: (data) => { return `Application ${data.flowIdentifier} is a paper submission that must be completed by ODNR.`; },
                        text: (data) => { return data.flowIdentifier; }
                    }
                }
            } else {
                return {
                    component: RouterLinkRendererComponent,
                    params: {
                        textField: 'flowIdentifier',
                        flowIdField: 'flowId'
                    }
                }
            }
        },
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
    } as ColDef;

    columnPendingTabApplicationNumber: ColDef = {
        headerName: 'Application #',
        headerTooltip: 'Application #',
        tooltipField: 'flowIdentifier',
        field: 'flowIdentifier',
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
    };

    columnCreatedDate = {
        headerName: 'Created',
        headerTooltip: 'Created',
        field: 'createdDate',
        tooltipValueGetter: this.gridFormatterService.formatDate('createdDate'),
        valueGetter: this.gridFormatterService.formatDate('createdDate'),
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: this.gridFormatterService.defaultDateFilterParams,
        minWidth: 135,
    } as ColDef;

    columnObjectToChangeDataType = {
        headerName: 'Type',
        headerTooltip: 'Type',
        field: 'dataType',
        minWidth: 135,
    } as ColDef;

    columnObjectToChangeId = {
        headerName: 'Number',
        headerTooltip: 'Number',
        field: 'objectToCorrectId',
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
        minWidth: 135,
    } as ColDef;

    public notSubmittedColumns: ColDef[] = [this.columnCreatedDate, this.columnApplicationNumberColumn, this.columnObjectToChangeDataType, this.columnObjectToChangeId];
    public pendingReviewColumns: ColDef[] = [this.columnCreatedDate, this.columnPendingTabApplicationNumber, this.columnObjectToChangeDataType, this.columnObjectToChangeId];
    public approvedReviewColumns: ColDef[] = [this.columnCreatedDate, this.columnPendingTabApplicationNumber, this.columnObjectToChangeDataType, this.columnObjectToChangeId];
    public deniedReviewColumns: ColDef[] = [this.columnCreatedDate, this.columnPendingTabApplicationNumber, this.columnObjectToChangeDataType, this.columnObjectToChangeId];
    public returnedReviewColumns: ColDef[] = [this.columnCreatedDate, this.columnApplicationNumberColumn, this.columnObjectToChangeDataType, this.columnObjectToChangeId];


    constructor(
        public workOrderService: WorkOrderService,
        public authService: AuthService,
        public datePipe: DatePipe,
        public dataCorrectionService: DataCorrectionService,
        public gridFormatterService: GridFormatterService,
        private flowInstanceService: FlowInstanceService,
        private router: Router,
        public dateService: DateService
    ) {
        this.subscriptions.add(this.flowInstanceService.getReturnedIncompleteApplication("InProgressCorrectionRequestApplications", false, this.user.organizationId)
            .subscribe((result: FlowIndex[]) => {
                this.notSubmittedDataCorrectionRequests = result;
            }));

        this.subscriptions.add(this.flowInstanceService.queryFlowIndices("PendingCorrectionRequestApplications", this.user.organizationId)
                .subscribe((result: FlowIndex[]) => {
                    this.pendingReviewDataCorrectionRequests = this.sortFlowIndices(result);
                }));

        this.subscriptions.add(this.flowInstanceService.getReturnedIncompleteApplication("ReturnedCorrectionRequestApplications", true, this.user.organizationId)
            .subscribe((result: FlowIndex[]) => {
                this.returnedDataCorrectionRequests = this.sortFlowIndices(result);
            }));

        this.subscriptions.add(this.flowInstanceService.queryFlowIndices("ApprovedCorrectionRequestApplications", this.user.organizationId)
                .subscribe((result: FlowIndex[]) => {
                    this.approvedDataCorrectionRequests = this.sortFlowIndices(result);
                }));

        this.subscriptions.add(this.flowInstanceService.queryFlowIndices("DeniedCorrectionRequestApplications", this.user.organizationId)
            .subscribe((result: FlowIndex[]) => {
                this.deniedDataCorrectionRequests = this.sortFlowIndices(result);
            }));
    }

    ngOnInit() {
		this.notSubmittedGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.notSubmittedColumns);
		this.notSubmittedGridOptions.onGridReady = (params) => {
			this.notSubmittedGridApi = params.api;
		};
		this.pendingReviewGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.pendingReviewColumns);
		this.pendingReviewGridOptions.onGridReady = (params) => {
			this.pendingReviewGridApi = params.api;
		};
		this.approvedGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.approvedReviewColumns);
		this.approvedGridOptions.onGridReady = (params) => {
			this.approvedGridApi = params.api;
		};
		this.deniedGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.deniedReviewColumns);
		this.deniedGridOptions.onGridReady = (params) => {
			this.deniedGridApi = params.api;
		};
        this.returnedGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.returnedReviewColumns);
		this.returnedGridOptions.onGridReady = (params) => {
			this.returnedGridApi = params.api;
		};

        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    onTabClicked(): void {
        this.notSubmittedGridApi.sizeColumnsToFit();
        this.pendingReviewGridApi.sizeColumnsToFit();
        this.approvedGridApi.sizeColumnsToFit();
        this.deniedGridApi.sizeColumnsToFit();
        this.returnedGridApi.sizeColumnsToFit();
    }

    get user(): UserIdentity {
        return this.authService.User;
    }

    sortFlowIndices(indices: FlowIndex[]): FlowIndex[] { //sort by date submitted if available, then by created date if not
        return indices.sort((a, b) => {
            if (a.dateSubmitted < b.dateSubmitted) return -1;
            if (a.dateSubmitted > b.dateSubmitted) return 1;
            if (a.createdDate < b.createdDate) return -1;
            if (a.createdDate > b.createdDate) return 1;
            return 0;
        });
    }
}
